import { render, staticRenderFns } from "./statistical.vue?vue&type=template&id=55d12e70&scoped=true"
import script from "./statistical.vue?vue&type=script&lang=js"
export * from "./statistical.vue?vue&type=script&lang=js"
import style0 from "./statistical.vue?vue&type=style&index=0&id=55d12e70&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d12e70",
  null
  
)

export default component.exports